import { Component, computed, inject, input, LOCALE_ID } from '@angular/core';
import { InvoiceBlockModel } from './invoice-block.model';
import { SubmitButton } from '../../../../../../../shared/ui/Buttons/submit-button/submit-button';
import { InvoiceIcon } from '../../../../../../../shared/ui/icons/invoice-icon/invoice-icon';
import { WalletIcon } from '../../../../../../../shared/ui/icons/wallet-icon/wallet-icon';
import { ProductBoxIcon } from '../../../../../../../shared/ui/icons/product-box-icon/product-box-icon';

@Component({
  selector: 'app-invoice-block',
  imports: [SubmitButton, InvoiceIcon, WalletIcon, ProductBoxIcon],
  templateUrl: './invoice-block.html',
  styleUrl: './invoice-block.scss',
})
export class InvoiceBlock {
  private localeId = inject(LOCALE_ID);
  isArabic = computed(() => this.localeId.startsWith('ar'));
  invoiceData = input<InvoiceBlockModel>();
  length = input<number>();
  itemIndex = input<number>();

  getStatusClass(status: any): string {
    if (!status) {
      return 'bg-status-neutral';
    }

    const rawStatus = typeof status === 'object' ? status.titleEn || status.titleAr || status.label || '' : status;

    const normalizedStatus = String(rawStatus).trim().toLowerCase();

    switch (normalizedStatus) {
      // ==========================================
      // SUCCESS
      // ==========================================
      case 'paid':
        return 'bg-status-success';

      // ==========================================
      // WARNING
      // ==========================================
      case 'partially paid':
        return 'bg-status-warning';

      // ==========================================
      // DANGER
      // ==========================================

      case 'rejected':
      case 'مرفوض':
        return 'bg-status-danger';

      // ==========================================
      // PURPLE
      // ==========================================

      case 'needs modification':
      case 'يحتاج إلي تعديل':
      case 'يحتاج الى تعديل':
      case 'needs_modification':
      case 'yearly':
        return 'bg-segment-purple';

      // ==========================================
      // INFO
      // ==========================================

      case 'printed':
      case 'shipped':
      case 'new':
      case 'in progress':
      case 'updated':
      case 'packaged':
      case 'return product received':
      case 'semi annual':
      case 'custom':
        return 'bg-status-info';

      // ==========================================
      // NEUTRAL
      // ==========================================

      case 'cancelled':
      case 'closed':

      case 'pending payment':
      default:
        return 'bg-status-neutral';
    }
  }
}
